import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import { AdvanceSearchService } from '../../services/Advance-search/advance-search.service';
import { ToastService } from '../../services/toast/toast.service';
import { UpdateFcPopupComponent } from './update-fc-popup/update-fc-popup.component';
import { EditDevoteeFcComponent } from "./edit-devotee-fc/edit-devotee-fc.component";
import { UpdateAllFcComponent } from './update-all-fc/update-all-fc.component';

@Component({
  selector: 'app-change-fc',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatDialogModule, EditDevoteeFcComponent],
  templateUrl: './change-fc.component.html',
  styleUrl: './change-fc.component.scss',
})
export class ChangeFcComponent implements OnInit {
  searchForm!: FormGroup;

  profileList: any[] = [];
  profileDetails: any[] = [];
  newMemberCode: string = ''
  updateMember: string = ''
  

  showEdit = false;
  accountExist: boolean = false;
  showEditFeature: boolean = false;
  newFc: string = '';
  selectedDevotee: any;
  isMobile: boolean = window.innerWidth <= 768;

  constructor(
    private fb: FormBuilder,
    private advanceService: AdvanceSearchService,
    private dialog: MatDialog,
    private toaster: ToastService
  ) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      familyCode: ['', [Validators.required, Validators.minLength(4)]],
    });
  }

  searchByFamilyCode(): void {
    if (this.searchForm.invalid) return;

    const payload = {
      key: this.searchForm.value.familyCode,
      keyType: 'familyCode',
      page: 1,
    };

    this.advanceService.fetchProfile(payload).subscribe({
      next: (res) => {
        this.profileList = res?.data || [];
        console.log("ptofileList",this.profileList)
      },
      error: () => {
        this.profileList = [];
      },
    });
  }

  getProfileDetails(familyCode: string): void {
    this.advanceService.fetchProfileDetails(familyCode).subscribe({
      next: (res) => {
        this.profileDetails = res?.data || [];
        console.log("profiledata",this.profileDetails)
        this.showEdit = true;
      },
      error: (err) => {
        this.toaster.error(err?.error?.message || 'Failed to load details');
      },
    });
  }

  back(): void {
    this.showEdit = false;
  }

  reset(): void {
    this.searchForm.reset();
    this.profileList = [];
    this.showEdit = false;
  }

  updateFamilyCode(item: any): void {
    console.log("item",item)
    const dialogRef = this.dialog.open(UpdateFcPopupComponent, {
      data:{ ...item,
        profileList:this.profileList
       },
    })

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if(res !== undefined){
        this.showEditFeature = true;
        this.accountExist = res.accntExist;
        this.newFc = res.newFc;
        this.newMemberCode = res.newMemberCode
        this.selectedDevotee = item
        this.updateMember = res.updateMember
        }
      }
    })
    // open popup / navigate / call API here
  }

    onCloseEdit(event: any){
    this.showEditFeature = event.value
    this.showEdit = true
    this.getProfileDetails(this.selectedDevotee.devoteeFamilyCode)
  }

 updateAllFamilyMembers(): void {

  const primaryMember =
    this.profileDetails?.find(
      (x: any) => x.isPrimaryDevotee
    ) || this.profileDetails?.[0];

  const dialogRef = this.dialog.open(
    UpdateAllFcComponent,
    {
      data: {
        ...primaryMember,
        profileList: this.profileList
      },
    }
  );

  dialogRef.afterClosed().subscribe({

    next: (res) => {

      if (res !== undefined) {

        // after moving the whole family, show the destination family code
        // (the old code no longer holds these members)
        this.getProfileDetails(
          res.newFamilyCode || primaryMember.devoteeFamilyCode
        );

      }

    }

  });

}
}
